// extracted by mini-css-extract-plugin
export default {"listItem":"BulletList_listItem__uvEZN","listItemBullet":"BulletList_listItemBullet__KXfw4","itemText":"BulletList_itemText__JlYPG"};